import { StoragePath } from './storage-path'

export class LocationFilter {
  private readonly _storagePath: StoragePath
  private readonly _deepSearch: boolean

  public static empty(): LocationFilter {
    return new LocationFilter(null, null)
  }

  constructor(storagePath: StoragePath, deepSearch: boolean) {
    this._storagePath = storagePath
    this._deepSearch = deepSearch
  }

  public get storagePath(): StoragePath {
    return this._storagePath
  }

  public get storagePathString(): string {
    return this.storagePath ? this.storagePath.serialize() : null
  }

  public get deepSearch(): boolean {
    return this._deepSearch
  }

  public withPath(path: StoragePath): LocationFilter {
    return new LocationFilter(path, this.deepSearch)
  }

  public withDeepSearch(deepSearch: boolean): LocationFilter {
    return new LocationFilter(this.storagePath, deepSearch)
  }
}
